"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateVisitorDtoPlatformEnum = void 0;
exports.instanceOfCreateVisitorDto = instanceOfCreateVisitorDto;
exports.CreateVisitorDtoFromJSON = CreateVisitorDtoFromJSON;
exports.CreateVisitorDtoFromJSONTyped = CreateVisitorDtoFromJSONTyped;
exports.CreateVisitorDtoToJSON = CreateVisitorDtoToJSON;
exports.CreateVisitorDtoToJSONTyped = CreateVisitorDtoToJSONTyped;
/**
 * @export
 */
exports.CreateVisitorDtoPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    AppleTv: 'apple_tv',
    AndroidTv: 'android_tv',
    Web: 'web'
};
/**
 * Check if a given object implements the CreateVisitorDto interface.
 */
function instanceOfCreateVisitorDto(value) {
    if (!('deviceFingerprint' in value) || value['deviceFingerprint'] === undefined)
        return false;
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('timezoneId' in value) || value['timezoneId'] === undefined)
        return false;
    return true;
}
function CreateVisitorDtoFromJSON(json) {
    return CreateVisitorDtoFromJSONTyped(json, false);
}
function CreateVisitorDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'deviceFingerprint': json['deviceFingerprint'],
        'platform': json['platform'],
        'timezoneId': json['timezoneId'],
    };
}
function CreateVisitorDtoToJSON(json) {
    return CreateVisitorDtoToJSONTyped(json, false);
}
function CreateVisitorDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'deviceFingerprint': value['deviceFingerprint'],
        'platform': value['platform'],
        'timezoneId': value['timezoneId'],
    };
}
